var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "FieldItem",
    { attrs: { id: _vm.id, label: _vm.$t(_vm.fieldConfig.label) } },
    [
      _c(
        "template",
        { slot: "label" },
        [
          _c("span", [_vm._v(_vm._s(_vm.$t(_vm.fieldConfig.label)))]),
          _c(
            "ElPopover",
            {
              attrs: {
                "visible-arrow": false,
                width: 366,
                placement: "right",
                trigger: "hover",
                "popper-class": "bio-search-setting__popover",
              },
            },
            [
              _c("PreferencesPropver", {
                attrs: {
                  type: "gaps",
                  "img-src": _vm.store.safeImagesUrl("ungappedExplanation"),
                },
              }),
              _c("PtIcon", {
                attrs: { slot: "reference", icon: "SolidInfo" },
                slot: "reference",
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "search-preference__gaps-label" }, [
        _c("label", { staticClass: "search-preferences--radio" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.fieldValue,
                expression: "fieldValue",
              },
            ],
            attrs: { type: "radio" },
            domProps: { value: true, checked: _vm._q(_vm.fieldValue, true) },
            on: {
              change: [
                function ($event) {
                  _vm.fieldValue = true
                },
                _vm.syncChange,
              ],
            },
          }),
          _c("span", { staticClass: "search-preferences--value" }, [
            _vm._v(" " + _vm._s(_vm.$t("Search.labels.yes")) + " "),
          ]),
        ]),
        _c("label", { staticClass: "search-preferences--radio" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.fieldValue,
                expression: "fieldValue",
              },
            ],
            attrs: { type: "radio" },
            domProps: { value: false, checked: _vm._q(_vm.fieldValue, false) },
            on: {
              change: [
                function ($event) {
                  _vm.fieldValue = false
                },
                _vm.syncChange,
              ],
            },
          }),
          _c("span", { staticClass: "search-preferences--value" }, [
            _vm._v(" " + _vm._s(_vm.$t("Search.labels.no")) + " "),
          ]),
        ]),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }